import { useEffect, useRef, useState } from 'react';

const CARD_W = 180;
const GAP = 15;

export function useColumns(value: number = 6) {
  const ref = useRef<HTMLDivElement>(null);
  const [columns, setColumns] = useState(value);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const ro = new ResizeObserver(() => {
      const width = el.clientWidth || 0;
      const cols = Math.max(1, Math.floor((width + GAP) / (CARD_W + GAP)));
      setColumns(cols);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return { ref, columns };
}
